import { render, staticRenderFns } from "./Educate.vue?vue&type=template&id=4c81c886&"
import script from "./Educate.vue?vue&type=script&lang=js&"
export * from "./Educate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports